import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled from 'styled-components';

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  bottom: ", "px;\n  left: ", "px;\n  position: absolute;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  max-width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledFigure = styled.figure(_templateObject());
var StyledImage = styled.img(_templateObject2());
var StyledCaption = styled.figcaption(_templateObject3(), function (_ref) {
  var theme = _ref.theme;
  return theme.space.xs;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.xs;
});

var Image = function Image(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      title = _ref.title,
      caption = _ref.caption,
      className = _ref.className;
  return React.createElement(StyledFigure, {
    className: className
  }, React.createElement(StyledImage, {
    src: src,
    alt: alt,
    title: title,
    className: className && "".concat(className, " ").concat(className, "-image")
  }), caption && React.createElement(StyledCaption, {
    className: className && "".concat(className, " ").concat(className, "-caption")
  }, caption));
};

Image.defaultProps = {
  caption: null,
  className: null,
  title: null
};
Image.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Image",
  "props": {
    "caption": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "An optional caption to be rendered on top of the image"
    },
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "title": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "An optional title for the image"
    },
    "src": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "The source path of the image"
    },
    "alt": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "The alternative text for the image"
    }
  }
};
export default Image;
export { Image };